// Die Formatierer der Oberfläche — rein, ohne DOM, getestet (format.test.ts).
// Alles deutsch, „—" für einen fehlenden Wert.

const nf = new Intl.NumberFormat("de-DE");

export const fmtInt = (n: number | null | undefined): string => (n === null || n === undefined ? "—" : nf.format(Math.round(n)));

export function fmtUsd(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "USD", maximumFractionDigits: n < 10 ? 2 : 0 }).format(n);
}

/** Euro mit zwei Nachkommastellen: „12,50 €". */
export const eur = (v: number | null | undefined): string =>
  (v === null || v === undefined ? "—" : `${Number(v).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`);

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" });
}

export function fmtDay(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString("de-DE");
}

/** „vor 5 Minuten" — für Stände und Läufe, wo die Uhrzeit allein nichts sagt. */
export function fmtAgo(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return "—";
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return String(iso);
  const s = Math.round((now - t) / 1000);
  if (s < 45) return "gerade eben";
  const m = Math.round(s / 60);
  if (m < 60) return m === 1 ? "vor 1 Minute" : `vor ${m} Minuten`;
  const h = Math.round(m / 60);
  if (h < 24) return h === 1 ? "vor 1 Stunde" : `vor ${h} Stunden`;
  const d = Math.round(h / 24);
  if (d < 14) return d === 1 ? "gestern" : `vor ${d} Tagen`;
  return fmtDay(iso);
}

/** Anteil in Prozent, auf 0–100 begrenzt; ohne Ganzes 0. */
export function pct(part: number, whole: number): number {
  return whole > 0 ? Math.max(0, Math.min(100, (100 * part) / whole)) : 0;
}

/** Tönung eines Füllstands: ab `warn` gelb, ab `error` rot. */
export function levelTone(p: number, warn = 80, error = 95): "" | "warn" | "error" {
  return p >= error ? "error" : p >= warn ? "warn" : "";
}

/** Der laufende Monat als `YYYY-MM` (UTC, wie der Server rechnet). */
export function currentMonth(now = new Date()): string {
  return now.toISOString().slice(0, 7);
}

/** Leer → `null`, sonst die Zahl (auch `NaN` — der Server prüft). */
export const numOrNull = (s: string | null | undefined): number | null => (String(s ?? "").trim() === "" ? null : Number(s));

/** Zeilen oder Kommas → Liste, getrimmt, ohne Leere. */
export const splitList = (s: string | null | undefined): string[] =>
  String(s ?? "").split(/[\n,]/).map((x) => x.trim()).filter(Boolean);

/**
 * Was ein Mandant im Monat kostet (USD): Plattform-Key, Flow-Key und die
 * Summe der Instanz (eigene Endpoints). Lizenzen (EUR) zählen nicht mit.
 */
export function monthCostUsd(c: { platform_key_spend_usd?: number; flow_key_spend_usd?: number; instance_usd?: number } | null | undefined): number {
  return (c?.platform_key_spend_usd ?? 0) + (c?.flow_key_spend_usd ?? 0) + (c?.instance_usd ?? 0);
}
